import {
  WellnessArticlesDocument,
  type WellnessArticlesInput,
  type WellnessArticlesQuery,
} from '@mdvip/shared/graphql/generated/graphql';
import { gqlRequest } from '@mdvip/shared/lib/graphql-client';

export type WellnessArticlesPage = WellnessArticlesQuery['wellnessArticles'];
export type WellnessArticle = WellnessArticlesPage['edges'][number];

/** `limit` is required here: the backend defaults it to 20 and rejects anything above 100. */
export type WellnessArticlesRequest = Omit<WellnessArticlesInput, 'offset' | 'limit' | 'topics'> & {
  offset: number;
  limit: number;
};

/** Prefix for invalidating every cached wellness-articles page at once. */
export const wellnessArticlesKey = ['wellness', 'wellnessArticles'] as const;

export async function requestWellnessArticles(input: WellnessArticlesRequest): Promise<WellnessArticlesPage> {
  const data = await gqlRequest(WellnessArticlesDocument, { input });
  return data.wellnessArticles;
}
